var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLightning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.677 12H6a4 4 0 1 1 0-8h1.416A5.001 5.001 0 0 1 16.9 5h1.6a3.5 3.5 0 0 1 0 7h-4.129l-.771 2.939h1.93c.177 0 .339.105.419.27a.54.54 0 0 1-.039.528l-4.806 7.057a.47.47 0 0 1-.38.206.5.5 0 0 1-.205-.05.515.515 0 0 1-.248-.587l1.13-4.302H9.47a.47.47 0 0 1-.419-.271.54.54 0 0 1 .039-.527z"
})));
export default SvgLightning;